require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-wealth-builder-program.json") })
        }
      }, "path---es-articles-wealth-builder-program");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-wealth-builder-program!./.cache/json/es-articles-wealth-builder-program.json
// module id = 2402
// module chunks = 231608221292675